import { Divider, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import Interpolate from 'components/Interpolate/Interpolate';
import { useTranslation } from 'next-i18next';
import { ProductUIChart } from '../product-ui-chart/product-ui-chart';
import { ProductUIGoal } from '../product-ui-goal/product-ui-goal';
import { ProductUIModal } from '../product-ui-modal/product-ui-modal';
import { ProductUITabs } from '../product-ui-tabs/product-ui-tabs';
import css from './product-ui-productivity-popover.module.css';
type ProductUIProductivityPopoverProps = {
  variant: 'weekly' | 'karma';
  x?: number | string;
  y?: number | string;
};
function ProductivityWeekly() {
  const {
    t
  } = useTranslation('productui');
  return <div className={css.popoverContainer} data-sentry-component="ProductivityWeekly" data-sentry-source-file="product-ui-productivity-popover.tsx">
            <div className={css.tabs}>
                <ProductUITabs data-sentry-element="ProductUITabs" data-sentry-source-file="product-ui-productivity-popover.tsx">
                    <ProductUITabs.Choice data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.daily')}</ProductUITabs.Choice>
                    <ProductUITabs.Choice selected={true} data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.weekly')}</ProductUITabs.Choice>
                    <ProductUITabs.Choice data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.karma')}</ProductUITabs.Choice>
                </ProductUITabs>
            </div>
            <div className={css.top}>
                <ProductUIGoal variant="weekly" data-sentry-element="ProductUIGoal" data-sentry-source-file="product-ui-productivity-popover.tsx" />
                <Text tag="span" size="body-2xs" data-sentry-element="Text" data-sentry-source-file="product-ui-productivity-popover.tsx">
                    <Interpolate t={t} i18nKey="productivityPopover.weeklyGoalCompleted" data-sentry-element="Interpolate" data-sentry-source-file="product-ui-productivity-popover.tsx" />
                </Text>
            </div>
            <Divider data-sentry-element="Divider" data-sentry-source-file="product-ui-productivity-popover.tsx" />
            <div className={css.bottom}>
                <Text weight="semibold" tag="span" size="minor-xs" className={cn(css.secondary)} data-sentry-element="Text" data-sentry-source-file="product-ui-productivity-popover.tsx">
                    {t('productivityPopover.lastFourWeeks')}
                </Text>
                <Image width={268} height={85} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/product-ui/productivity-popover/weekly-chart.svg`} alt="" data-sentry-element="Image" data-sentry-source-file="product-ui-productivity-popover.tsx" />
            </div>
        </div>;
}
function ProductivityKarma() {
  const {
    t
  } = useTranslation('productui');
  return <div className={css.popoverContainer} data-sentry-component="ProductivityKarma" data-sentry-source-file="product-ui-productivity-popover.tsx">
            <div className={css.tabs}>
                <ProductUITabs data-sentry-element="ProductUITabs" data-sentry-source-file="product-ui-productivity-popover.tsx">
                    <ProductUITabs.Choice data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.daily')}</ProductUITabs.Choice>
                    <ProductUITabs.Choice data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.weekly')}</ProductUITabs.Choice>
                    <ProductUITabs.Choice selected={true} data-sentry-element="unknown" data-sentry-source-file="product-ui-productivity-popover.tsx">{t('tabs.karma')}</ProductUITabs.Choice>
                </ProductUITabs>
            </div>
            <div className={css.top}>
                <ProductUIGoal variant="karma" data-sentry-element="ProductUIGoal" data-sentry-source-file="product-ui-productivity-popover.tsx" />
                <div>
                    <Text tag="div" size="body-2xs" data-sentry-element="Text" data-sentry-source-file="product-ui-productivity-popover.tsx">
                        <Interpolate t={t} i18nKey="productivityPopover.youAreAnExpert" data-sentry-element="Interpolate" data-sentry-source-file="product-ui-productivity-popover.tsx" />
                    </Text>
                    <Text className={css.secondary} tag="div" size="body-2xs" weight="medium" data-sentry-element="Text" data-sentry-source-file="product-ui-productivity-popover.tsx">
                        {t('productivityPopover.nextLevel')}
                    </Text>
                </div>
            </div>
            <Divider data-sentry-element="Divider" data-sentry-source-file="product-ui-productivity-popover.tsx" />
            <div className={css.bottom}>
                <Text weight="semibold" tag="span" size="minor-xs" className={cn(css.secondary)} data-sentry-element="Text" data-sentry-source-file="product-ui-productivity-popover.tsx">
                    {t('productivityPopover.karmaTrend')}
                </Text>
                <ProductUIChart data-sentry-element="ProductUIChart" data-sentry-source-file="product-ui-productivity-popover.tsx" />
            </div>
        </div>;
}
function ProductUIProductivityPopover({
  variant,
  x,
  y
}: ProductUIProductivityPopoverProps) {
  const {
    t
  } = useTranslation('productui');
  return <ProductUIModal title={t('productivityPopover.productivity')} x={x} y={y} data-sentry-element="ProductUIModal" data-sentry-component="ProductUIProductivityPopover" data-sentry-source-file="product-ui-productivity-popover.tsx">
            {variant === 'weekly' ? <ProductivityWeekly /> : <ProductivityKarma />}
        </ProductUIModal>;
}
export { ProductUIProductivityPopover };